import { makeAutoObservable, runInAction } from "mobx";
import ApiStore from "./ApiStore";

export type CurrencyExchangeRate = {
  id: number;
  date: string;
  currencyName: string;
  currentValueInDollars: number;
};

class CurrencyExchangeRateStore {
  ApiStore!: ApiStore;

  isLoading = false;
  currentRate: CurrencyExchangeRate | null = null;

  currentCurrency = "USD"; // TODO: If dynamic definition of currency and company is implemented, then remove the hard code and implement dynamic definition
  unitsPerUsd = 1; // TODO: Can be transferred to the database

  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
  }

  setCurrentCurrency = (currentCurrency: string) => {
    this.currentCurrency = currentCurrency;
  };

  getLatestCurrencyExchangeRate = async () => {
    this.isLoading = true;
    try {
      const currentRate = await this.ApiStore.CurrencyExchangeRateApiClient.getLatestCurrencyExchangeRate(this.currentCurrency.toUpperCase());

      runInAction(() => {
        this.currentRate = currentRate;

        const usdPerUnit = currentRate?.currentValueInDollars ?? 1;
        this.unitsPerUsd = usdPerUnit > 0 ? 1 / usdPerUnit : 1;
      });
    } catch (e) {
      console.error("Error fetching current rate:", e);

      runInAction(() => {
        this.currentRate = null;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}

export default CurrencyExchangeRateStore;
